import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AppDetails from '@/plugins/graphql/queries/v2/ecommerce/app-details.gql';
import { EcommerceAppModel } from '../../helpers/entities/models/EcommerceAppModel';
import ViewportSizeMixin from '../../helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '../../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
let PageTitle = class PageTitle extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin) {
    constructor() {
        super(...arguments);
        this.appDetails = null;
    }
    get generateTitle() {
        if (this.$route.name === 'apps-dashboard') {
            return this.$store.getters['session/isStoreManagerLogin'] ? 'My Stores' : 'My In-App Stores';
        }
        return this.$route.meta.title;
    }
    get generateSubTitle() {
        return this.$route.meta.subtitle;
    }
    trackSegment(merchant) {
        const root = this.diy ? 'DIY' : 'Dashboard';
        const path = this.xsOnly && this.diy ? `${this.step} ${this.generateTitle}` : this.generateTitle;
        const eventName = `${root} - ${path} View`;
        this.segmentTrack(eventName, { merchant });
    }
    mounted() {
        if (!this.appUuid) {
            this.$apollo.queries.appDetails.stop();
        }
    }
};
__decorate([
    Getter('appUuid')
], PageTitle.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageTitle.prototype, "diy", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageTitle.prototype, "noPadding", void 0);
__decorate([
    Prop({ type: String, default: '' })
], PageTitle.prototype, "step", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageTitle.prototype, "small", void 0);
__decorate([
    Prop({ type: String, default: null })
], PageTitle.prototype, "customTitle", void 0);
__decorate([
    Prop({ type: String, default: null })
], PageTitle.prototype, "customSubtitle", void 0);
PageTitle = __decorate([
    Component({
        filters: {
            toDiyTitle(value, isDiyTitle, step) {
                if (isDiyTitle) {
                    return `${step} ${value}`;
                }
                return value;
            },
        },
        apollo: {
            appDetails: {
                query: AppDetails,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const vm = this;
                    const app = new EcommerceAppModel(data.ecommerceAppDetails);
                    vm.trackSegment(app?.name);
                    return app;
                },
            },
        },
    })
], PageTitle);
export default PageTitle;
